import type { KftApiDefaultResponse } from '~/composables/types/kft-api'
import type {
  GiftcardTheme,
  GiftcardThemeShowcase,
} from '~/composables/types/giftcardTheme'
import { mapGiftcardThemes } from '~/utils/giftcardThemes'

/**
 * Themed gift cards (designs, sample PDF title/message) managed in the back
 * office as the `kft-giftcard-themes` dynamic content. Returned, not awaited -
 * await it in `<script setup>` so SSR renders with the data.
 */
export const useGiftcardThemes = () => {
  const { locale } = useI18n()

  return useKftApiFetch<
    KftApiDefaultResponse<GiftcardThemeShowcase[]>,
    GiftcardTheme[]
  >('/v1/store/gift-card/themes', {
    method: 'GET',
    // the API localizes titles/names via Accept-Language
    key: `giftcard-themes-${locale.value}`,
    dedupe: 'defer',
    // the showcase sits on several page types - reuse the themes on client
    // navigation instead of refetching them on every page
    getCachedData: (key) => useNuxtData(key).data.value ?? undefined,
    transform: (response) => mapGiftcardThemes(response?.data ?? []),
  })
}
